import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5v14","key":"svg-0"}]]

const IconMinusVertical = createReactComponent('outline', 'minus-vertical', 'MinusVertical', __iconNode);

export default IconMinusVertical;